import { render, staticRenderFns } from "./Resize.vue?vue&type=template&id=73ab2ab9&"
import script from "./Resize.vue?vue&type=script&lang=js&"
export * from "./Resize.vue?vue&type=script&lang=js&"
import style0 from "./Resize.vue?vue&type=style&index=0&id=73ab2ab9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports